import { ObjectProperties } from '../../shared/types'
import { Button } from '../components/button'
import { ObjectPropertyField } from '../components/object-property-field'
import { FormLayout as Layout } from './types'

type FormLayoutProps<T> = {
	layout: Layout
	data?: T
}

const COLUMNS: Record<number, string> = {
	1: 'grid-cols-1',
	2: 'grid-cols-2',
	3: 'grid-cols-3',
}

export function FormLayout<T extends ObjectProperties>({ layout, data }: FormLayoutProps<T>) {
	return layout.map((element, index) => {
		switch (element.type) {
			case '__header':
				return (
					<h4 key={index} className="text-sm font-bold">
						{element.text}
					</h4>
				)
			case '__text':
				return (
					<p key={index} className="text-sm">
						{element.text}
					</p>
				)
			case '__button':
				return (
					<Button variant={element.variant} type="button">
						{element.text}
					</Button>
				)
			case 'section':
				return (
					<div key={index} className={`grid ${COLUMNS[element.columns ?? 1]} gap-4`}>
						<FormLayout layout={element.components} data={data} />
					</div>
				)
			case 'condition': {
				const matchingCondition = element.conditions.find(
					condition => data?.[condition.when.field] === condition.when.value,
				)

				const layoutToRender = matchingCondition?.then || element.else || []

				return (
					<div key={index}>
						<FormLayout layout={layoutToRender} data={data} />
					</div>
				)
			}
			case 'actionRow':
				return null
			default:
				return (
					<ObjectPropertyField
						key={element.identifier}
						value={data?.[element.identifier]}
						data={data}
						{...element}
					/>
				)
		}
	})
}
